/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendInvitationDto } from '../../models/backend-invitation-dto';

export interface AccessProjectsInvitationsList$Params {
  project_id: number;
}

export function accessProjectsInvitationsList(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsInvitationsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendInvitationDto>>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsInvitationsList.PATH, 'get');
  if (params) {
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendInvitationDto>>;
    }),
  );
}

accessProjectsInvitationsList.PATH = '/api/access/projects/{project_id}/invitations/';
